import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import EmployerOnboarding from "@/pages/EmployerOnboarding";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/employer-onboarding")({
  head: () => seoHead("/employer-onboarding"),
  component: () => (
    <AuthGate><EmployerOnboarding /></AuthGate>
  ),
});
